/**
 * Max complete-study upload size, in MB. Single source of truth for both the
 * single-study page (UploadStudyPage) and the batch folder hook
 * (useBatchUpload) — override with the `VITE_UPLOAD_MAX_MB` env var.
 */
export const UPLOAD_MAX_MB = Number(import.meta.env.VITE_UPLOAD_MAX_MB ?? "8192");

/** Keep the established one-request path for studies at or below 1 GiB. */
export const UPLOAD_SINGLE_REQUEST_MB = Number(
  import.meta.env.VITE_UPLOAD_SINGLE_REQUEST_MB ?? "1024",
);

/**
 * Raw DICOM bytes placed in one large-study request. 256 MiB keeps browser
 * memory bounded while being large enough that multipart/ticket overhead is
 * negligible. The receiver's per-request ceiling remains 1 GiB.
 */
export const UPLOAD_BATCH_MB = Number(import.meta.env.VITE_UPLOAD_BATCH_MB ?? "256");
